export default __webpack_public_path__ + "static/media/elevate-red-1.360b3ed5.png";